export default __webpack_public_path__ + "static/media/vect-waves.12d94047.svg";